import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UnsupportedFilterTypeWarning from 'flow-doctor-lib/components/filters/UnsupportedFilterTypeWarning';
import { RemoveIcon, SuccessIcon, WarningIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListBranchDebugFilterBranchSection = ({
  logEvent,
  branchNum,
  branchConnection,
  historicalEvalBranch
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const filterBranch = branchConnection.filterBranch;
  React.useEffect(() => {
    if (historicalEvalBranch && historicalEvalBranch.acceptedStatus === 'ACCEPTED') {
      setIsExpanded(true);
    }
  }, [historicalEvalBranch, setIsExpanded]);
  return /*#__PURE__*/_jsx(UIExpandableSection, {
    "data-test-id": `list-branch-debug-panel-expandable-section`,
    open: isExpanded,
    onOpenChange: () => setIsExpanded(!isExpanded),
    titleText: branchConnection.branchName ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.listBranchDebugPanel.branchNumberAndName",
      options: {
        branchNum,
        branchName: branchConnection.branchName
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.listBranchDebugPanel.branchNumber",
      options: {
        branchNum
      }
    }),
    actions: historicalEvalBranch ? /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.listBranchDebugPanel.evalFailed"
      }),
      disabled: !!historicalEvalBranch,
      children: !historicalEvalBranch ? /*#__PURE__*/_jsx(WarningIcon, {
        color: "do-not-use-marigold-dark",
        size: "400"
      }) : historicalEvalBranch.acceptedStatus === 'ACCEPTED' ? /*#__PURE__*/_jsx(SuccessIcon, {
        color: "do-not-use-oz-dark",
        size: "400"
      }) : /*#__PURE__*/_jsx(RemoveIcon, {
        color: "do-not-use-candy-apple-dark",
        size: "400"
      })
    }) : null,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [historicalEvalBranch && /*#__PURE__*/_jsx(UnsupportedFilterTypeWarning, {
        mode: "LIST_BRANCH",
        filterBranch: filterBranch
      }), /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
        filterBranch: filterBranch,
        debugOptions: historicalEvalBranch && {
          filterBranch: historicalEvalBranch,
          displayMode: 'ALL'
        },
        objectTypeId: logEvent.objectTypeId,
        filterWidthType: "LIST_FIXED"
      })]
    })
  });
};
export default ListBranchDebugFilterBranchSection;